import type { Dictionary } from "./en";

const id: Dictionary = {
  meta: {
    title: "Bale's — Iqbal Aulia, Developer Kreatif",
  },
  nav: {
    home: "Beranda",
    about: "Tentang",
    services: "Layanan",
    journey: "Perjalanan",
    contact: "Kontak",
    templates: "Template",
    switchLanguage: "Switch to English",
  },
  home: {
    profileAlt: "Foto Iqbal Aulia",
    buildingDigital: ["membangun pengalaman", "digital"],
    craftingInnovative: ["merancang solusi", "digital yang inovatif"],
    typing: ["Programming", "bukan", "sekadar"],
    quoteBody: [
      "soal menulis kode",
      "tapi soal memecahkan masalah dengan",
      "kreativitas dan semangat.",
    ],
    quoteFail: ["Jangan takut gagal", "takutlah untuk tidak mencoba"],
    quoteAuthor: "Anonim",
    serviceIntro: [
      "Saya menyediakan jasa development profesional",
      "untuk membantu mewujudkan",
      "ide Anda.",
    ],
    qualityCode: "Kode berkualitas",
    qualityFor: "untuk",
    qualityProject: "proyek Anda",
    serviceLines: [
      { label: "Front End", stack: "React · Vue · TS", note: "UI presisi" },
      { label: "Back End", stack: "Node · REST · SQL", note: "API yang skalabel" },
      { label: "Full Stack", stack: "End-to-end", note: "Dari ide sampai rilis" },
    ],
    explore: ["jelajahi proyek", "terbaru saya"],
    showcasing: ["menampilkan solusi", "web kreatif"],
    seeMore: "lihat lainnya",
    tagline: ["Mengubah ide", "menjadi kode, dan", "visi menjadi nyata."],
  },
  services: {
    headerKicker:
      "solusi website lengkap untuk landing page, blog, e-commerce, dan lainnya",
    headerTitle: ["[Sistem", "Digital]"],
    contactUs: "Hubungi Kami",
    yearsExperience: "Tahun Pengalaman",
    featuresTitle: "apa saja fitur kami ?",
    featureBody:
      "Menangani pembuatan & pemeliharaan website, mulai dari perencanaan, desain, coding, pengujian, sampai rilis.",
    features: [
      "Gratis Domain + SSL",
      "Desain Modern",
      "Ramah SEO",
      "Website Responsif",
      "Copywriting",
    ],
    growthTotal:
      "Selama ini saya telah menyelesaikan lebih dari 25 proyek, membuktikan keahlian dan dedikasi dalam memberikan solusi terbaik. Portofolio saya mencakup beragam proyek, mulai dari aplikasi mobile hingga pengembangan website menyeluruh. Setiap proyek adalah bukti komitmen saya pada kualitas dan inovasi.",
    growthMobile:
      "Saya bangga telah menyelesaikan lebih dari 10 proyek aplikasi mobile berkualitas tinggi. Setiap aplikasi dirancang untuk memberikan pengalaman pengguna terbaik dan memenuhi kebutuhan spesifik klien.",
    growthWebsite:
      "Saya telah menyelesaikan lebih dari 15 proyek pengembangan website berkualitas tinggi. Setiap website dirancang untuk memberikan pengalaman pengguna terbaik dan memenuhi kebutuhan spesifik klien.",
    toolsProject: "Tools Proyek",
    skillsTitle: "Keahlian",
    skillsBody: [
      "Keahlian saya mencakup berbagai bidang teknologi dan pengembangan,",
      "dari frontend hingga backend, untuk solusi yang menyeluruh",
      "sesuai kebutuhan proyek Anda.",
    ],
    teams: ["Marketing", "Server", "Desain", "SEO", "Developer"],
    packagesTitle: "Paket Terbaik",
    packagesBody:
      "Pilih paket yang disusun sesuai kebutuhan bisnis Anda. Harga transparan, kode standar produksi, dan pendampingan sampai website Anda online.",
    packagePrefix: "Paket",
    detail: "Detail",
    orderNow: "Pesan Sekarang!",
    customTitle: "Website Custom",
    customBody:
      "Butuh website yang benar-benar sesuai kebutuhan bisnis Anda? Kami menyediakan jasa pembuatan website custom yang bisa didiskusikan sesuai keinginan Anda. Dapatkan solusi yang tepat dan unik untuk bisnis Anda dengan berdiskusi bersama tim kami!",
    customTemplateHint: "Budget lebih kecil? Mulai dari template siap pakai di",
    discuss: "Diskusi Dengan Kami",
    orderMessage: (pkg: string, price: string) =>
      `Halo!\nNama saya ....\nSaya ingin bertanya tentang jasa pembuatan website dengan paket ${pkg} (${price}).\n\nDetail Pesanan:\nNama: ......\nPaket: ${pkg}\nEmail: ......\nTelepon / WhatsApp: .....\nLanding Page / Company Profile: .....`,
    customMessage:
      "Halo!\nNama saya ....\nSaya ingin bertanya tentang jasa pembuatan website custom.\n\nDetail Pesanan:\nNama: ......\nEmail: ......\nTelepon / WhatsApp: .....\nDetail Website Custom: .....",
  },
  about: {
    headline: ["bersemangat", "menciptakan", "pengalaman", "web yang", "luar biasa"],
    name: "Alex Johnson",
    pictureAlt: "Foto profil",
    describe: [
      "Sebagai Front-end web developer, saya membawa semangat dalam coding dan komitmen untuk menghadirkan website responsif berkualitas tinggi bagi klien. Dengan pengalaman luas di HTML, CSS, dan JavaScript / TypeScript, saya terampil membuat antarmuka yang menarik dan mudah digunakan untuk bisnis dan organisasi dari berbagai skala.",
      "Saya memahami prinsip desain pengalaman pengguna dengan baik dan menggunakannya untuk membuat website yang menarik, mudah dinavigasi, dan teroptimasi untuk mesin pencari. Saya juga mahir menggunakan berbagai tools dan framework Front-end seperti React dan Vue.js untuk membangun aplikasi web yang andal dan dinamis.",
      "Kemampuan bekerja sama dengan klien dan rekan kerja untuk memahami kebutuhan mereka dan memberikan solusi yang tepat adalah ciri khas pekerjaan saya. Baik di proyek besar maupun tugas individu, saya mengutamakan ketelitian, ketepatan waktu, dan kode yang bersih serta mudah dirawat.",
    ],
    tools: "Tools",
    currentPosition: "Posisi Saat Ini",
    quote:
      "\" Terkadang kita harus menyelam jauh ke dalam diri sendiri untuk memecahkan masalah.\" - Patrick Star",
    testimonialBy: "testimoni dari",
    followUs: "Ikuti Kami",
  },
  contact: {
    kicker: "hubungi kami",
    title: ["yuk ngobrol, hubungi", "Kami"],
    body: "punya pertanyaan atau masukan ? Kami siap membantu. Kirim pesan, dan kami akan membalas dalam 24 jam.",
    firstName: "Nama Depan",
    lastName: "Nama Belakang",
    email: "Alamat Email",
    message: "Pesan",
    send: "Kirim Pesan!",
    waMessage: (name: string, email: string, message: string) =>
      `Halo!\nNama saya ${name}.\nEmail: ${email}\nPesan:\n${message}`,
  },
  history: {
    title: "Pengalaman",
    description: [
      "Halaman ini menampilkan berbagai pengalaman dan",
      "proyek yang pernah saya kerjakan sepanjang karier.",
      "Di sini Anda dapat melihat informasi lengkap tentang",
      "perjalanan profesional, keahlian, dan pencapaian saya.",
    ],
    professional: "Profesional",
    freelance: "Freelance",
    detail: "Detail",
    present: "Sekarang",
    emptyState: (type: string) => `Proyek ${type} akan segera diperbarui.`,
    workType: {
      Hybrid: "Hybrid",
      Remote: "Remote",
      Onsite: "Di kantor",
    },
    employmentType: {
      "Full-time": "Penuh waktu",
      Internship: "Magang",
      Freelance: "Freelance",
    },
  },
  footer: {
    about: "tentang",
    service: "layanan",
    templates: "template",
    contact: "hubungi kami",
    newsletter:
      "dapatkan insight industri yang bermanfaat & jika ada pertanyaan jangan ragu menghubungi kami",
    emailPlaceholder: "Masukkan Email Anda",
  },
  whatsapp: {
    alt: "Chat lewat WhatsApp",
    message:
      "Halo Iqbal!\nPerkenalkan saya ... ingin bertanya mengenai jasa pembuatan website.",
  },
  empty: {
    message: [
      "Ups! Halaman yang Anda cari tidak ditemukan.",
      "Mungkin sudah dipindahkan atau dihapus.",
    ],
  },
};

export default id;
